var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"header",staticClass:"hiq-header-lgw"},[_c('Logotype'),(!_vm.isMobile)?_c('MenuButtons'):_vm._e(),(_vm.showMenu && !_vm.isMobile)?_c('Menu'):_vm._e(),_c('OriginLink'),(_vm.isMobile)?_c('MobileMenuButton'):_vm._e(),(_vm.showMenu && _vm.isMobile)?_c('MobileMenu',{attrs:{"height":_vm.height}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }